export const calendarDayOfWeek_Thursday = "aOvuN";
export default {calendarDayOfWeek_Thursday};